import { render, staticRenderFns } from "./table-sender-summary.vue?vue&type=template&id=a110c65a&scoped=true&"
import script from "./table-sender-summary.vue?vue&type=script&lang=js&"
export * from "./table-sender-summary.vue?vue&type=script&lang=js&"
import style0 from "./table-sender-summary.vue?vue&type=style&index=0&id=a110c65a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a110c65a",
  null
  
)

export default component.exports